import HEADER_BACKGROUND from "./HEADER_BACKGROUND.jpeg";
import HOME_BANNER_1 from "./HOME_BANNER_1.jpg";
import HOME_BANNER_2 from "./HOME_BANNER_2.jpg";
import HOME_BANNER_3 from "./HOME_BANNER_3.png";
import SERVICIOS_CUBAS from "./SERVICIOS_CUBAS.png";
import SERVICIOS_PIEZAS from "./SERVICIOS_PIEZAS.png";
import SERVICIOS_BODEGAS from "./SERVICIOS_BODEGAS.png";
import CLIENTE_1 from "./CLIENTE_1.png";
import CLIENTE_2 from "./CLIENTE_2.png";
import CLIENTE_3 from "./CLIENTE_3.png";
import CLIENTE_4 from "./CLIENTE_4.png";
import CLIENTE_5 from "./CLIENTE_5.png";
import CLIENTE_6 from "./CLIENTE_6.png";
import CLIENTE_7 from "./CLIENTE_7.png";
import CLIENTE_8 from "./CLIENTE_8.png";
import CLIENTE_9 from "./CLIENTE_9.png";
import CLIENTE_10 from "./CLIENTE_10.png";
import CLIENTE_11 from "./CLIENTE_11.png";
import CLIENTE_12 from "./CLIENTE_12.png";
import CLIENTE_13 from "./CLIENTE_13.png";
import CLIENTE_14 from "./CLIENTE_14.png";
import CLIENTE_15 from "./CLIENTE_15.png";
import CLIENTE_16 from "./CLIENTE_16.png";
import CUBUS_06 from "./CUBUS_0.6.png";
import CUBUS_022 from "./CUBUS_0.22.png";
import CUBUS_10 from "./CUBUS_1.0.png";
import CUBUS_15 from "./CUBUS_1.5.png";
import CUBUS_30 from "./CUBUS_3.0.png";
import LAGAR_35 from "./LAGAR_3.5.png";
import CUBUS_50 from "./CUBUS_5.0.png";
import CUBUS_100 from "./CUBUS_10.0.png";
import SLIDE_CONCREBLOQ from "./SLIDE_CONCREBLOQ.png";
import SLIDE_CONCRECAM_1 from "./SLIDE_CONCRECAM_1.jpg";
import SLIDE_CONCRECAM_2 from "./SLIDE_CONCRECAM_2.jpg";
import SLIDE_CONCRECAM_3 from "./SLIDE_CONCRECAM_3.jpg";
import SLIDE_CAMELLON_1 from "./SLIDE_CAMELLON_1.jpg";
import SLIDE_CAMELLON_2 from "./SLIDE_CAMELLON_2.jpg";
import SLIDE_CAMELLON_3 from "./SLIDE_CAMELLON_3.jpg";
import SLIDE_CAMELLON_4 from "./SLIDE_CAMELLON_4.jpg";
import SLIDE_CAMELLON_5 from "./SLIDE_CAMELLON_5.jpg";
import SLIDE_CAMELLON_6 from "./SLIDE_CAMELLON_6.jpg";
import SLIDE_CAMELLON_7 from "./SLIDE_CAMELLON_7.jpg";
import SLIDE_ESCALERAS_1 from "./SLIDE_ESCALERAS_1.jpg";
import SLIDE_ESCALERAS_2 from "./SLIDE_ESCALERAS_2.JPG";
import SLIDE_ESCALERAS_3 from "./SLIDE_ESCALERAS_3.JPG";
import SLIDE_ESCALERAS_5 from "./SLIDE_ESCALERAS_5.jpg";
import SLIDE_ESCALERAS_6 from "./SLIDE_ESCALERAS_6.jpg";
import SLIDE_ESCALERAS_7 from "./SLIDE_ESCALERAS_7.jpg";
import SLIDE_ESCALERAS_8 from "./SLIDE_ESCALERAS_8.jpg";
import SLIDE_ESCALERAS_9 from "./SLIDE_ESCALERAS_9.jpg";
import SLIDE_HENRIQUEZ_1 from "./SLIDE_HENRIQUEZ_1.jpg";
import SLIDE_HENRIQUEZ_2 from "./SLIDE_HENRIQUEZ_2.jpg";
import SLIDE_HENRIQUEZ_3 from "./SLIDE_HENRIQUEZ_3.jpg";
import SLIDE_HENRIQUEZ_4 from "./SLIDE_HENRIQUEZ_4.jpg";
import SLIDE_HENRIQUEZ_5 from "./SLIDE_HENRIQUEZ_5.jpg";
import SLIDE_HENRIQUEZ_6 from "./SLIDE_HENRIQUEZ_6.jpg";
import SLIDE_HENRIQUEZ_7 from "./SLIDE_HENRIQUEZ_7.jpg";
import SLIDE_HENRIQUEZ_8 from "./SLIDE_HENRIQUEZ_8.jpg";
import SLIDE_HENRIQUEZ_9 from "./SLIDE_HENRIQUEZ_9.jpg";
import SLIDE_PARRA_1 from "./SLIDE_PARRA_1.jpg";
import SLIDE_PARRA_2 from "./SLIDE_PARRA_2.jpg";
import SLIDE_PARRA_3 from "./SLIDE_PARRA_3.jpg";
import SLIDE_PARRA_4 from "./SLIDE_PARRA_4.jpg";
import SLIDE_PARRA_5 from "./SLIDE_PARRA_5.jpg";
import SLIDE_PARRA_6 from "./SLIDE_PARRA_6.jpeg";
import SLIDE_PARRA_7 from "./SLIDE_PARRA_7.jpg";
import SLIDE_PARRA_8 from "./SLIDE_PARRA_8.jpg";
import SLIDE_PARRA_9 from "./SLIDE_PARRA_9.jpg";
import SLIDE_PARRA_10 from "./SLIDE_PARRA_10.jpeg";
import JOSE from "./JOSE.png";
import GIORDANO from "./GIORDANO.png";
import SERGIO from "./SERGIO.png";

export const IMAGES = {
  HEADER_BACKGROUND,
  HOME_BANNER_1,
  HOME_BANNER_2,
  HOME_BANNER_3,
  SERVICIOS_CUBAS,
  SERVICIOS_PIEZAS,
  SERVICIOS_BODEGAS,
  CLIENTE_1,
  CLIENTE_2,
  CLIENTE_3,
  CLIENTE_4,
  CLIENTE_5,
  CLIENTE_6,
  CLIENTE_7,
  CLIENTE_8,
  CLIENTE_9,
  CLIENTE_10,
  CLIENTE_11,
  CLIENTE_12,
  CLIENTE_13,
  CLIENTE_14,
  CLIENTE_15,
  CLIENTE_16,
  CUBUS_06,
  CUBUS_022,
  CUBUS_10,
  CUBUS_15,
  CUBUS_30,
  LAGAR_35,
  CUBUS_50,
  CUBUS_100,
  SLIDE_CONCREBLOQ,
  SLIDE_CONCRECAM_1,
  SLIDE_CONCRECAM_2,
  SLIDE_CONCRECAM_3,
  SLIDE_CAMELLON_1,
  SLIDE_CAMELLON_2,
  SLIDE_CAMELLON_3,
  SLIDE_CAMELLON_4,
  SLIDE_CAMELLON_5,
  SLIDE_CAMELLON_6,
  SLIDE_CAMELLON_7,
  SLIDE_ESCALERAS_1,
  SLIDE_ESCALERAS_2,
  SLIDE_ESCALERAS_3,
  SLIDE_ESCALERAS_5,
  SLIDE_ESCALERAS_6,
  SLIDE_ESCALERAS_7,
  SLIDE_ESCALERAS_8,
  SLIDE_ESCALERAS_9,
  SLIDE_HENRIQUEZ_1,
  SLIDE_HENRIQUEZ_2,
  SLIDE_HENRIQUEZ_3,
  SLIDE_HENRIQUEZ_4,
  SLIDE_HENRIQUEZ_5,
  SLIDE_HENRIQUEZ_6,
  SLIDE_HENRIQUEZ_7,
  SLIDE_HENRIQUEZ_8,
  SLIDE_HENRIQUEZ_9,
  SLIDE_PARRA_1,
  SLIDE_PARRA_2,
  SLIDE_PARRA_3,
  SLIDE_PARRA_4,
  SLIDE_PARRA_5,
  SLIDE_PARRA_6,
  SLIDE_PARRA_7,
  SLIDE_PARRA_8,
  SLIDE_PARRA_9,
  SLIDE_PARRA_10,
  JOSE,
  GIORDANO,
  SERGIO,
};
